import React from 'react';

import {
  Container,
  ItemsContainer,
  ItemRadio,
  ItemImage,
  ItemLabel,
  SelectedImageContainer,
  SelectedImage,
} from './ImagePicker.style';

export interface IImagePickerItem {
  url: string;
}

interface IGetValidItem {
  selectedItem: IImagePickerItem;
  items: IImagePickerItem[];
  fallbackItemIndex: number;
}
/**
 * Returns selected item if found in items, else returns fallback item
 */
const getValidSelectedItem = ({
  selectedItem,
  items,
  fallbackItemIndex,
}: IGetValidItem): IImagePickerItem => {
  const isSelectedItemFound = items.find(
    (item) => item.url === selectedItem.url
  );
  return isSelectedItemFound ? isSelectedItemFound : items[fallbackItemIndex];
};

/**
 * Item
 */
interface IItem {
  item: IImagePickerItem;
  selectedItem: IImagePickerItem;
  onChange: ({ item }: { item: IImagePickerItem }) => any;
}
const Item: React.FC<IItem> = (props) => {
  const { item, selectedItem, onChange } = props;
  const { url } = item;
  return (
    <>
      <ItemRadio
        type="radio"
        name={url}
        value={url}
        id={url}
        checked={selectedItem.url === url}
        onChange={(): any => onChange({ item })}
      />
      <ItemLabel htmlFor={url}>
        <ItemImage src={url} />
      </ItemLabel>
    </>
  );
};

/**
 * Selected item
 */
interface ISelectedItem {
  item: IImagePickerItem;
}
const SelectedItem: React.FC<ISelectedItem> = (props) => {
  const { item } = props;
  const { url } = item;

  return (
    <SelectedImageContainer>
      <SelectedImage src={url} />
    </SelectedImageContainer>
  );
};

/**
 * Image picker
 */
interface IImagePicker {
  items: IImagePickerItem[];
  selectedItem: IImagePickerItem;
  fallbackItemIndex: number;
  onChange: ({ item }: { item: IImagePickerItem }) => any;
}
const ImagePicker: React.FC<IImagePicker> = (props) => {
  const { items, onChange, fallbackItemIndex } = props;
  let { selectedItem } = props;
  selectedItem = getValidSelectedItem({
    selectedItem,
    items,
    fallbackItemIndex,
  });

  return (
    <Container>
      <SelectedItem item={selectedItem} />
      <ItemsContainer>
        {items.map((item, index) => (
          <Item
            key={`image-picker-item-${index}`}
            item={item}
            selectedItem={selectedItem}
            onChange={onChange}
          />
        ))}
      </ItemsContainer>
    </Container>
  );
};

export default ImagePicker;
